import { EChainType } from '@/constants/chains'
import { INVITATION_CODE_ENDPOINT } from '@/data/endpoint'

import { IResponse, Model, ObjectsFactory } from '../../core'

export interface IGenerateAccessCodePayload {
  walletAddress?: string
}

export interface ILinkWalletWithReferralCodeParams {
  code: string
  walletAddress: string
  publicKey: string
  chainType: EChainType
  timestamp: number
  signature: string
}
export type ILinkWalletWithReferralCodeRes = {
  message: string
}
export interface IWalletReferralParams {
  walletAddress?: string
  page?: number
  limit?: number
}
export interface IWalletReferralParamsByReferralCode {
  referralCode: string
}

export interface IGenerateReferralCodeRes {
  code: string
}

export interface IReferrerInfo {
  id: number
  referrer: string
  referee: string
  accessCodeId: number
  accessCode: string
  createdAt: string
  updatedAt: string
}
export interface IReferrerInfoByReferralCode {
  code: string
  createdAt: string
  createdBy: string
  id: number
  updatedAt: string
}
export class AccessCodeModel extends Model {
  static config = { endpoint: INVITATION_CODE_ENDPOINT.BASE }

  static objects = ObjectsFactory.factory<void>(AccessCodeModel.config)

  static generateAccessCode(payload: IGenerateAccessCodePayload) {
    return this.service.post<IResponse<IGenerateReferralCodeRes>>({
      url: INVITATION_CODE_ENDPOINT.GENERATE_CODE,
      payload: payload,
    })
  }

  static linkWalletWithReferralCode(payload: ILinkWalletWithReferralCodeParams) {
    return this.service.post<IResponse<ILinkWalletWithReferralCodeRes>>({
      url: INVITATION_CODE_ENDPOINT.LINK_WALLET_WITH_REFERRAL_CODE,
      payload: payload,
    })
  }
  static getReferrerInfo(payload: IWalletReferralParams) {
    return this.service.get<IResponse<IReferrerInfo>>({
      url: `${INVITATION_CODE_ENDPOINT.GET_REFERRER_INFO}/${payload.walletAddress}`,
    })
  }
  static getReferrerInfoByReferralCode(payload: IWalletReferralParamsByReferralCode) {
    return this.service.get<IResponse<IReferrerInfoByReferralCode>>({
      url: `${INVITATION_CODE_ENDPOINT.GET_REFERRER_INFO_BY_REFERRAL_CODE}/${payload.referralCode}`,
    })
  }
}

AccessCodeModel.init(AccessCodeModel.config)
